import React, { useState } from 'react';

const StudentFormFields = ({ fields, onChange }) => {
  const [values, setValues] = useState({});

  const handleChange = (field_id, value) => {
    // Enforce the configured max length (value_length), incl. number inputs.
    const f = fields.find((x) => x.id === field_id);
    let v = value;
    const maxLen = f ? parseInt(f.value_length) : NaN;
    if (!isNaN(maxLen) && maxLen > 0 && typeof v === "string" && v.length > maxLen) {
      v = v.slice(0, maxLen);
    }
    const updated = { ...values, [field_id]: v };
    setValues(updated);

    // Send array to parent
    const arr = Object.entries(updated).map(([id, val]) => ({
      field_id: parseInt(id),
      field_value: val,
    }));
    onChange(arr);
  };

  const getOptions = (options) => {
    if (!options) return [];
    if (Array.isArray(options)) {
      return options.map(opt => typeof opt === 'string' ? { label: opt, value: opt } : opt);
    }
    return options.toString().split(',').map(o => ({ label: o.trim(), value: o.trim() })).filter(o => o.label);
  };

  return (
    <>
      {fields.map((field) => {
        // Prioritize field_type_id (numeric from DB) over field_type (string label)
        let typeId = 1;
        if (field.field_type_id != null && !isNaN(parseInt(field.field_type_id))) {
          typeId = parseInt(field.field_type_id);
        } else {
          const rawType = (field.field_type || "").toString().trim().toLowerCase();
          if (rawType === "1" || rawType === "text") typeId = 1;
          else if (rawType === "2" || rawType === "textarea") typeId = 2;
          else if (rawType === "3" || rawType === "number") typeId = 3;
          else if (rawType === "4" || rawType === "dropdown" || rawType === "select") typeId = 4;
          else if (rawType === "5" || rawType === "radio" || rawType === "radiobutton") typeId = 5;
          else if (rawType === "6" || rawType === "date") typeId = 6;
          else if (rawType === "7" || rawType === "checkbox") typeId = 7;
        }

        const isRequired = field.is_required === 1 || field.is_required === true;
        const fieldValue = values[field.id] || '';

        return (
          <div key={field.id} className="col-md-6 px-2 form-group mb-4">
            <label className="font-weight-bold mb-2 d-block" style={{ fontSize: '14px', color: '#334155' }}>
              {field.field_name}
              {isRequired 
                ? <span className="text-danger ml-1">*</span>
                : <span className="text-muted ml-1" style={{ fontSize: '12px', fontWeight: 'normal' }}>(optional)</span>
              }
            </label>

            {/* 1: TEXT */}
            {typeId === 1 && (
              <input
                type="text"
                className="form-control"
                placeholder={`Enter ${field.field_name}`}
                required={isRequired}
                maxLength={field.value_length || undefined}
                value={fieldValue}
                onChange={(e) => handleChange(field.id, e.target.value)}
              />
            )}

            {/* 2: TEXTAREA */}
            {typeId === 2 && (
              <textarea
                className="form-control"
                placeholder={`Enter ${field.field_name}`}
                required={isRequired}
                rows={4}
                maxLength={field.value_length || undefined}
                value={fieldValue}
                onChange={(e) => handleChange(field.id, e.target.value)}
              />
            )}

            {/* 3: NUMBER */}
            {typeId === 3 && (
              <input
                type="number"
                className="form-control"
                placeholder={`Enter ${field.field_name}`}
                required={isRequired}
                maxLength={field.value_length || undefined}
                value={fieldValue}
                onChange={(e) => handleChange(field.id, e.target.value)}
              />
            )}

            {/* 4: DROPDOWN */}
            {typeId === 4 && (
              <select
                className="form-control"
                required={isRequired}
                value={fieldValue}
                onChange={(e) => handleChange(field.id, e.target.value)}
              >
                <option value="">-- Select {field.field_name} --</option>
                {getOptions(field.options).map((opt, idx) => (
                  <option key={idx} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            )}

            {/* 5: RADIO */}
            {typeId === 5 && (
              <div className="d-flex flex-wrap" style={{ gap: '15px' }}>
                {getOptions(field.options).map((opt, idx) => (
                  <label key={idx} className="d-flex align-items-center mb-0 cursor-pointer" style={{ gap: '6px' }}>
                    <input 
                      type="radio" 
                      name={`radio_${field.id}`}
                      checked={fieldValue === opt.value}
                      onChange={() => handleChange(field.id, opt.value)}
                      required={isRequired}
                    />
                    <span style={{ fontSize: '14px', color: '#475569' }}>{opt.label}</span>
                  </label>
                ))}
              </div>
            )}

            {/* 6: DATE */}
            {typeId === 6 && (
              <input
                type="date"
                className="form-control"
                required={isRequired}
                value={fieldValue}
                onChange={(e) => handleChange(field.id, e.target.value)}
                style={{ borderRadius: '8px', padding: '10px 12px' }}
              />
            )}

            {/* 7: CHECKBOX */}
            {typeId === 7 && (
              <div className="d-flex flex-wrap" style={{ gap: '15px' }}>
                {getOptions(field.options).map((opt, idx) => {
                    const currentValues = fieldValue ? fieldValue.split(',') : [];
                    return (
                        <label key={idx} className="d-flex align-items-center mb-0 cursor-pointer" style={{ gap: '6px' }}>
                            <input 
                                type="checkbox" 
                                checked={currentValues.includes(opt.value)}
                                onChange={(e) => {
                                    let newValues = [...currentValues];
                                    if (e.target.checked) newValues.push(opt.value);
                                    else newValues = newValues.filter(v => v !== opt.value);
                                    handleChange(field.id, newValues.join(','));
                                }}
                            />
                            <span style={{ fontSize: '14px', color: '#475569' }}>{opt.label}</span>
                        </label>
                    );
                })}
              </div>
            )}

          </div>
        );
      })}
    </>
  );
};

export default StudentFormFields;
